import { Button } from '@chakra-ui/button';
import { useColorMode, useColorModeValue } from '@chakra-ui/color-mode';
import { Flex, Box, Text, Heading, Stack } from '@chakra-ui/layout';
import { Skeleton } from '@chakra-ui/skeleton';
import Groups from './Groups';
import TopRightOptions from './TopRightOptions';
import Categories from './Categories';
import WorkspacePicker from './WorkspacePicker';
import layoutStore from '../stores/layoutStore';
import { motion, isValidMotionProp } from 'framer-motion';
import { Portal } from '@chakra-ui/react';
import useDndStore from '../stores/dndStore';
import DragOverlayItem from './dnd/DragOverlayItem';
import { chakra, shouldForwardProp } from '@chakra-ui/react';
import { useState } from 'react';
import usePersistStore from '../stores/persistStore';
import {
    DndContext,
    DragOverlay,
    useSensor,
    useSensors,
    MouseSensor as LibMouseSensor,
    MouseSensorOptions,
    PointerSensor as LibPointerSensor,
    MouseSensor,
    closestCenter
} from '@dnd-kit/core';
import { createPortal } from 'react-dom';
import { customCollisionDetectionAlgorithm } from './dnd/customCollisionFunctions';
import { handleDragStart } from './dnd/handleDragStart';
import { handleDragEnd } from './dnd/handleDragEnd';
import { createDefaultDropAnimation } from './dnd/customDropAnimation';
import WorkspacesGrid from './WorkspacesGrid';
import useStore from '../stores/store';
import TrashDropZone from './TrashDropZone';
import { useKeyPress } from '../hooks/useKeyPress';
import { useCallback } from 'react';

const DNDWrapper = ({ children }) => {
    let activationConstraint = {
        distance: 2
    };
    const dragAndDropSensors = useSensors(
        useSensor(MouseSensor, { activationConstraint })
    );
    const handleDragCancel = () => {
        // let hideDragIds = {};
        // useDndStore.getState().dragIds.forEach((id) => {
        //     hideDragIds[id] = true;
        // });

        // useDndStore.setState({ hideDragIds: hideDragIds });
        useDndStore.getState().resetStates();
    };


    const isShiftKeyPressed = useKeyPress('Shift');

    const handleDragEndMid = useCallback(({ active, over }) => {
        handleDragEnd(active, over, isShiftKeyPressed());
    }, [isShiftKeyPressed]);
    return (
        <Flex h="100vh" w="100vw" bg="bg0">
            <DndContext
                sensors={dragAndDropSensors}
                onDragStart={({ active }) => handleDragStart(active)}
                // onDragOver={({ active, over }) => handleDragOver(active, over)}
                // onDragOver={({ active, over }) => console.log('over', over)}
                onDragEnd={handleDragEndMid}
                onDragCancel={handleDragCancel}
                // collisionDetection={closestCenter}
                collisionDetection={(args) =>
                    customCollisionDetectionAlgorithm({
                        ...args
                    })
                }
            >
                {children}
                <Portal>
                    <DragOverlay dropAnimation={null}>
                        <DragOverlayItem />
                    </DragOverlay>
                </Portal>
                <TrashDropZone />
            </DndContext>
        </Flex>
    );
};

export default DNDWrapper;
